import {Component, input, Input, InputSignal} from '@angular/core';
import {ApplicationAppEntityApplicationRead, ShipmentAppEntityShipmentRead} from '../../../../../openapi';
import {
  AgreementsDataPreviewComponent
} from '../../common/agreements-data-section/components/agreements-data-preview/agreements-data-preview.component';
import {
  ApplicantPreviewComponent
} from '../../common/applicant-data-section/components/applicant-preview/applicant-preview.component';
import {
  ApplicationDataPreviewComponent
} from '../../common/application-data-section/components/application-data-preview/application-data-preview.component';
import {
  AttachmentsDataPreviewComponent
} from '../../common/attachments-data-section/components/attachments-data-preview/attachments-data-preview.component';
import {CommonModule, DatePipe} from '@angular/common';
import {DecisionDataPreviewComponent} from '../../common/decision-data-preview/decision-data-preview.component';
import {LabelComponent} from '../../../../../common/label/label.component';
import {ParcelsPreviewComponent} from '../../common/components/parcels/parcels-preview/parcels-preview.component';
import {ApplicationPipe} from '../../../../../pipes/application/application.pipe';
import {
  ContractorDataPreviewComponent
} from "../../common/contractor-data-section/components/contractor-data-preview/contractor-data-preview.component";

@Component({
  selector: 'app-opinion-on-the-project-of-traffic-org-preview',
  standalone: true,
  imports: [
    AgreementsDataPreviewComponent,
    ApplicantPreviewComponent,
    ApplicationDataPreviewComponent,
    AttachmentsDataPreviewComponent,
    DatePipe,
    DecisionDataPreviewComponent,
    LabelComponent,
    CommonModule,
    ParcelsPreviewComponent,
    ApplicationPipe,
    ContractorDataPreviewComponent
  ],
  templateUrl: './opinion-on-the-project-of-traffic-org-preview.component.html'
})
export class OpinionOnTheProjectOfTrafficOrgPreviewComponent {

  @Input()
  public expanded: boolean = true;

  public application: InputSignal<ApplicationAppEntityApplicationRead | null> = input<ApplicationAppEntityApplicationRead | null>(null);

  public shipments: InputSignal<ShipmentAppEntityShipmentRead[]> = input<ShipmentAppEntityShipmentRead[]>([]);

  public canPay: InputSignal<boolean> = input<boolean>(false);

}
